import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import iconHome from '../assets/images/_Breadcrumb items core.png'; // Import home icon image

const Breadcrumb = ({ items }) => {
    if (!items || items.length === 0) return null;

    return (
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0" style={{ background: 'transparent', padding: 0 }}>
                {items.map((item, index) => {
                    const isLast = index === items.length - 1;

                    // Determine Icon
                    let Icon = item.icon;
                    if (!Icon) {
                        if (item.label.toLowerCase() === 'home') {
                            Icon = <img src={iconHome} alt="Home" width="16" className="mb-1" />;
                        }
                        // Explicitly REMOVED the auto-icon for 'market' to match user request
                        // else if (item.label.toLowerCase().includes('market')) {
                        //     Icon = <FaChartLine className="mb-1" />;
                        // }
                    }

                    return (
                        <li
                            key={index}
                            className={`breadcrumb-item ${isLast ? 'active' : ''}`}
                            aria-current={isLast ? 'page' : undefined}
                            style={{ fontSize: '0.9rem', fontWeight: 500 }}
                        >
                            {isLast ? (
                                <span className="text-secondary d-flex align-items-center gap-1">
                                    {Icon && <span className="text-muted">{Icon}</span>}
                                    {item.label}
                                </span>
                            ) : (
                                <Link
                                    to={item.link || '#'}
                                    className="commonColor text-decoration-none d-flex align-items-center gap-1"
                                >
                                    {Icon && <span>{Icon}</span>}
                                    {item.label}
                                </Link>
                            )}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
};

Breadcrumb.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            link: PropTypes.string,
        })
    ).isRequired,
};

export default Breadcrumb;
